module.exports = __webpack_public_path__ + "img/鎏金面膜_02.9ca38f57.jpg";